import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "./style/style.scss";
import React, { Suspense, lazy, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, } from 'react-router-dom';
import Layout from "./components/layout";
import Login from "./auth/login/Login";
import PrivateRoute from './_providers/requireAuth';
import { useAuth } from './_services/authService';
import ForgotPassword from "./auth/login/ForgotPassword";
import Register from "./auth/login/Register";
import { MyProvider } from "./contextProvider/provider";
import Login2 from "./auth/login/Login2";
import ForgotPassword2 from "./auth/login/ForgotPassword2";
// import { getCurrentUser } from './_services/authService';
// const Login = lazy(() => import('./auth/login/Login'));
// const Dashboard = lazy(() => import('./components/dashboard/Dashboard'));
// const CreateUser = lazy(() => import('./components/users/CreateUser'));

export const config = {
  endpoint: `https://ess.spicejet.com/esswebapi/api`,
  //endpoint: `https://sgentdev.spicejet.com/devessapi/api`,
  baseUrl: 'ess_react'
};

function App() {
  const { token } = useAuth();
  const isAuthenticated = !!token;

  return (

    <div className="App">
      <MyProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                isAuthenticated
                  ? <Navigate to="/dashboard" />
                  : <Navigate to="/login" />
              }
            />

            <Route path="/login" element={<Login2 />} />
            {/* <Route path="/login2" element={<Login />} />
            <Route path="/forgot-password2" element={<ForgotPassword />} /> */}
            <Route path="/forgot-password" element={<ForgotPassword2 />} />
            <Route path="/user-register" element={<Register />} />

            <Route path="*" element={<PrivateRoute isAuthenticated={isAuthenticated} loginPath="/login"><Layout /></PrivateRoute>} />
          </Routes>
        </BrowserRouter>
      </MyProvider>
    </div>
  );
}

export default App;
